// src/context/ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within ThemeProvider');
    }
    return context;
};

export const ThemeProvider = ({ children }) => {
    // Load saved theme preference or default to 'classic'
    const [theme, setTheme] = useState(() => {
        const saved = localStorage.getItem('torque-theme');
        return saved || 'classic';
    });

    // Save theme preference whenever it changes
    useEffect(() => {
        localStorage.setItem('torque-theme', theme);
        // Add theme class to body for CSS targeting
        document.body.className = `theme-${theme}`;
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prev => prev === 'classic' ? 'enhanced' : 'classic');
    };

    const isEnhanced = theme === 'enhanced';
    const isClassic = theme === 'classic';

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, isEnhanced, isClassic }}>
            {children}
        </ThemeContext.Provider>
    );
};
